<template>
  <div id="tianguanjin">
    <NavBar />

    <div id="hero" class="hero overlay subpage-hero">
      <div class="hero-content">
        <div class="hero-text">
          <h1>天官金</h1>
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/">首页</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link to="/products">产品</router-link>
            </li>
            <li class="breadcrumb-item active">天官金</li>
          </ol>
        </div>
        <!-- /.hero-text -->
      </div>
      <!-- /.hero-content -->
    </div>
    <!-- /.hero -->

    <main id="main" class="site-main">
      <section class="site-section subpage-site-section section-project">
        <div class="container">
          <div class="row">
            <div class="col-md-12 mb-4">
              <div class="project-img">
                <img
                  :src="require('@/assets/img/products/tian-guan-jin.jpg')"
                  class="img-res mx-auto"
                  alt=""
                />
              </div>
              <!-- /.project-img -->
            </div>
            <aside class="col-md-12">
              <div class="project-info text-justify">
                <h5>『天官金』</h5>

                <p class="project-description">
                  <span><b>供奉天神焚化「天官金」</b></span>
                </p>

                <p class="project-description">
                  <span><b>赦罪赐福财运亨通 </b></span>
                </p>

                <p class="project-description">
                  天官金」可以随时 在供奉天神时 ，即时焚化， 即可得玉皇至
                  尊大慈大悲， 赦免众信从长 久沉沦苦海中 ，真正彻底救
                  赎，保佑智慧 大开，身体健康， 财运亨通。
                </p>

                <p class="project-description">
                  华人的住 宅中，传统上 除了安置本身 信奉的神衹， 如备受尊崇的
                  观世音菩萨、 关帝圣君、法主公、神德正神、齐天
                  大圣、哪吒三太子、玄天上帝等，视 个人与神衹的结缘。
                </p>

                <p class="project-description">
                  根据大马华人供奉神衹的习惯， 供奉观世音菩萨与关帝君最多，不同
                  籍贯的人，供奉的神衹，或者与经营
                  的事业，与供奉的神衹都有很大的差 异。
                </p>

                <p class="project-description">
                  <span><b>天神与天官赐福 </b></span>
                  但是，除了观世音菩萨与关帝圣 君最受众人供奉之外，另一个极受尊
                  崇的神衹，必然是家家户户都拥戴的
                  天神，一般上都安置在门的左手边〔
                  从内向外望〉，目前最盛行的是大红
                  龛,置放在屋门前的明堂位,对着大门（斜45度） ，内裡摆放着
                  一个匾牌，写 着「天官赐福 」四个字。 民间将天 官视为福神，
                  题祈福膜拜的 对象，这与民 间所说的「福 星高照」，具 有相同的意
                  义。 福星又称 为岁星，原指 木星，后来转 为化神。
                </p>

                <p class="project-description">
                  <span><b>三官大帝的由来 </b></span>
                  道教有“三官”神信仰，三官又 称为三官关帝，即所谓的天官、地官
                  、水官三神，也有称“三元”。 根据了解，天官乃赐福、地官赦
                  罪、水官解厄。 根据民间习俗正月初九为天公诞。
                  天官赐福，广泛传诵成为民间的 吉祥话、福字成为家家户户祈福的标
                  志，近年来还流行告华人农曆新春彳圭
                  节中，把「福」字倒转来张贴，意喻 天官「降福」人间。
                </p>

                <p class="project-description">
                  <span><b>苗大大师鑽研开发 </b></span>
                  諸葛孔明有限公司明白到民间众信多供奉天官(天神),
                  一般上只在初一、十五上香, 殊不知欲得天神的「祝福」,
                  必须透过具体实际的自我救赎，赦罪赐福，才能消弭宿世业障。
                  苗大大师近年来不断研发拜祭圣 品，从早期的「万佛神香油」与「万
                  佛神奇液」，之后又创研备受众信推
                  崇的「文武财神宝库」以及风靡神料
                  界的「还债金」，之后又有「太岁殿
                  」、「寿生钱」及「地主金」，成为
                  本邦最抢手的拜祭圣品，甚至遭不法 之徒抄袭、彷冒。
                </p>

                <p class="project-description">
                  <span><b>须诚心发心忏悔 </b></span>
                  今年，苗大再接再厉，创研开发 「天官金」，就是配合众信的所需，
                  在膜拜天神（天官〉时，透过焚化「
                  天官金」，保佑智慧大开，身体健康 、财运亨通。
                  不必等初一或十五，「天官金」 可以随时在供奉天神时，即时焚化，
                  即可得玉皇至尊大慈大悲，赦免众^[言
                  从长久沉沦苦海中，真正彻底救赎。 众信在供奉「天神」焚化「天官
                  金」时，必须发心忏悔向善。 忏悔向善是非常重要的。
                  据了解，忏悔向善诚心焚化「天 官金」，可除罪一千五百万劫，悉得
                  解脱、众邪、违道，一切怨鬼不得来 近、寿命正长、终不横死。
                </p>

                <p class="project-description">
                  <span><b>为什么要焚化《天官金》： </b></span>
                </p>

                <p class="project-description">
                  世间只知佛菩萨慈悲，却不知玉皇至尊大慈大悲，和世间诸多圣哲
                  与佛菩萨虽也宣示善恶果报，劝人修
                  行，以求解脱苦道恶途；但这就像营
                  养师保健师，虽劝人保健之法，却无
                  实际对症下药的医病能力，因为他们
                  无能力对治个别业障，无法详尽彻底
                  解消人业障。然则无上慈悲的玉皇
                  至尊则能真正彻底救赎，能对每一种
                  个别业障详尽对治，能对恶世苦果对
                  症下药；因为每个人的宿世行为与性
                  格功过，全部经功曹天神纪录，分类
                  整理各别优劣功过，并彙总呈报玉帝
                  ；玉帝则敕命南北斗星君据其罪福因
                  缘，而以南斗六星，北斗九星来陶铸
                  每个人的基本魂魄气数，如此则构成
                  了每个人详尽宿世因果与命格气数；
                  大慈悲的玉帝为免世人长久沉沦苦海
                  不能自拔；又特开大慈悲大智慧救赎
                  法门，对于能发心忏悔向善之善信，
                  准以礼拜南北斗妙法，具体实际的自我救赎、赦罪赐福；对于不知生辰八
                  字者，也可以向三官大帝祈求救赎赦
                  罪解厄道法，来消弥宿世业障；所以
                  玉帝慈悲之至深至切乃非一般神明所 能比拟。
                </p>

                <p class="project-description">
                  善男子善女人能奉行常焚化《天 官金》者，……终不令横死，……能
                  除无数劫生死极重之罪，能度无量无
                  边阿僧祇众生悉得解脱，众邪、违道
                  、一切怨鬼不得来近，寿命正长，终不横死，所欲求者，如愿悉得。
                </p>
              </div>
              <!-- /.project-description -->
            </aside>
          </div>
        </div>
      </section>
      <!-- /.section-project -->

      <RelatedProduct productCode="tian-guan-jin" />
    </main>
    <!-- /#main -->

    <Footer />
  </div>
</template>

<script>
/* eslint-disable */
import NavBar from "../partials/NavBar.vue";
import Footer from "../partials/Footer.vue";
import RelatedProduct from "./RelatedProduct.vue";

export default {
  name: "TianGuanJin",
  data() {
    return {};
  },
  components: {
    NavBar,
    Footer,
    RelatedProduct
  },
  created() {}
};
</script>



// WEBPACK FOOTER //
// src/components/products/TianGuanJin.vue